export interface Select {
  value: string | number | undefined;
  label: string | undefined;
}

export type FlagsState = {
  flg_fora_linha: boolean;
  flg_alcoolico: boolean;
  flg_atual_vda_assoc: boolean;
  flg_veda_cred_lim: boolean;
  flg_veda_cred: boolean;
  flg_nao_pis_cofins: boolean;
  flg_lei_complementar_224: boolean;
  flg_fabricante: boolean;
  flg_rastreavel: boolean;
  flg_lib_fiscal: boolean;

  flg_vale_gas: boolean;
  flg_permite_parc: boolean;
  flg_explosao_venda: boolean;
  flg_atualiza_custo_decomp: boolean;
  flg_explosao_compra: boolean;
  flg_consumo_monitorado: boolean;
  flg_envia_pdv: boolean;
  flg_envia_balanca: boolean;
  flg_ipv: boolean;
};

export type FlagsUpdater =
  | Partial<FlagsState>
  | ((prev: FlagsState) => Partial<FlagsState>);

export const initialFlags: FlagsState = {
  flg_fora_linha: false,
  flg_alcoolico: false,
  flg_atual_vda_assoc: false,
  flg_veda_cred_lim: false,
  flg_veda_cred: false,
  flg_nao_pis_cofins: false,
  flg_lei_complementar_224: false,
  flg_fabricante: false,
  flg_rastreavel: false,
  flg_lib_fiscal: false,
  flg_vale_gas: false,
  flg_permite_parc: false,
  flg_explosao_venda: false,
  flg_atualiza_custo_decomp: false,
  flg_explosao_compra: false,
  flg_consumo_monitorado: false,
  flg_envia_pdv: true,
  flg_envia_balanca: false,
  flg_ipv: false,
};

export type rowsIbsProps = {
  value: number;
  label: string;
  cod_ibs_cbs: number;
  des_classif_trib: number;
  cod_cst_ibs_cbs: number;
  des_ibs_cbs: string;
  per_aliq_cbs: number;
  per_red_cbs: number;
  val_red_social: number;
  cst_ibs_cbs: number;
};

export interface Embalagem {
  cod_gtin: string | number | undefined;
  des_unidade: string | number | undefined;
  qtd_embalagem: number;
  val_peso_emb: string;
  val_peso_bruto: string;
  flg_principal: boolean;
  qtd_divisor_preco: string;
  des_unidade_medida_preco: string | number | undefined;
}

export interface Associado {
  id?: string | undefined;
  cod_produto: string | number | undefined;
  des_produto: string;
  cod_gtin?: string | undefined;
  des_departamento: string;
  qtd_estoque: number;
  per_desc_assoc: string;
  per_acresc_assoc: string;
  flg_atual_vda_assoc: boolean;
}

export interface ITipoItem {
  cod_tipo_item: number;
  num_tipo_item: string;
  des_tipo_item: string;
}

export interface ILoja {
  des_uf: string;
  cod_loja: number;
  des_fantasia: string;
  des_cidade: string;
  cst_pis_cof_ent_aliq_zero: string;
  cst_pis_cof_ent_monof: string;
  cst_pis_cof_ent_subst: string;
  cst_pis_cof_ent_imune: string;
  cst_pis_cof_ent_susp: string;
  cst_pis_cof_entrada: string;
  cst_pis_cof_saida_aliq_zero: string;
  cst_pis_cof_saida_monof: string;
  cst_pis_cof_saida_subst: string;
  cst_pis_cof_saida_imune: string;
  cst_pis_cof_saida_susp: string;
  cst_pis_cof_saida: string;
}

export interface IDepartamento {
  cod_departamento: number;
  descricao: string;
  cod_tipo_item: number;
  des_tipo_item: string;
  cod_id_ctb: number;
}

export interface IProdutoDerivado {
  uuid: string;
  cod_seq_produto_derivado: number;
  cod_produto_derivado: string;
  cod_departamento?: { label: string; value: number };
  des_produto: string;
  cod_tipo_ajuste: { label: string; value: number };
  des_ajuste: string;
  des_unidade: { label: string; value: string };
}

export interface IGtin {
  cod_gtin: string;
}

export type MapeamentoValores = {
  '-1': { entrada: string; saida: string };
  '0': { entrada: string; saida: string };
  '1': { entrada: string; saida: string };
  '2': { entrada: string; saida: string };
  '3': { entrada: string; saida: string };
  '4': { entrada: string; saida: string };
  '5': { entrada: string; saida: string };
};
